import { ITableReclamationColumn } from "@components/TableReclamation/TableReclamation";

export const TableHeaderReclamation: ITableReclamationColumn[] = [
  { option: "ID do registro", align: "left", key: "1" },
  { option: "Razão social", align: "left", key: "2" },
  { option: "CNPJ", align: "center", key: "3" },
  { option: "Data da Solicitação", align: "right", key: "4" },
  { option: "Usuário Solicitante", align: "center", key: "5" },
  { option: "Tipo de Registro", align: "left", key: "6" },
  { option: "Status", align: "left", key: "7" },
  { option: "", align: undefined, key: "8" },
];
